define('modules/base/models/list.model',[
    'underscore',
    'backbone',
    'modules/base/models/base.paging.model'
], function (_, Backbone, BasePagingModel) {
    var ListModel = BasePagingModel.extend({
        pageNumber: 1,
        pageSize: 20,
        creating: false,
        updating: false,
        base: 'user/list',
        url:function(){
            if(this.creating){
                var base = 'prospector/v1/user/list';
                base = window.utils.makeUrl(base);
                return base;
            }else if (this.updating){
                return BasePagingModel.prototype.url.call(this);
            }else{
                var base = 'prospector/v1/user/list?sourceId=' + this.sourceId + '&refId=' + this.refId;
                base = window.utils.makeUrl(base);
                if(this.page != undefined){
                    base = base + '&page=' + this.page + '&pageSize=' + this.pageSize;
                }
                if(this.query != undefined && this.query != ""){
                    base = base + '&query=' + this.query;
                }
                if(this.sortField != undefined){
                    base = base + '&sortField=' + this.sortField + '&sortOrder=' + this.sortOrder;
                }
                this.set({id: null});
                return base;
            }
        }
    });
    return ListModel;
});

